import {
    Directive,
    ElementRef,
    Input,
    OnDestroy,
} from '@angular/core';

declare var $: any;

@Directive({
    selector: '[nddSparkline]',
})
export class NDDSparklineDirective implements OnDestroy {

    /**
     * Configuração do gráfico jquery.sparkline. Ver mais: https://omnipotent.net/jquery.sparkline/#bar
     */
    @Input() public sparklineOptions: any;

    @Input()
    set sparklineData(value: any) {
        this.values = value;
        this.initSparkLine();
    }
    public values: any;

    // Generate a unique resize event so we can detach later
    // tslint:disable-next-line:no-magic-numbers
    private resizeEventId: string = 'resize.sparkline' + 1324;
    private $element: any;

    constructor(el: ElementRef) {
        this.$element = $(el.nativeElement);
    }
    public ngOnDestroy(): void {
        $(window).off(this.resizeEventId);
    }

    public initSparkLine(): void {
        let options: any = this.sparklineOptions;
        const data: any = this.$element.data();

        if (!options) {// If no scope options, try with data attributes
            options = data;
        } else {
            if (data) {// Data attributes overrides scope options
                options = $.extend({}, options, data);
            }
        }

        options.type = options.type || 'bar'; // Default chart is bar
        options.disableHiddenCheck = true;

        this.runSparkline(options);

        if (options.resize) {
            $(window).on(this.resizeEventId, () => {
                this.runSparkline(options);
            });
        }
    }

    private runSparkline(options: any): void {
        if (this.values) {
            if (typeof this.values === 'string') {
                this.values = this.values.split(','); // Assume comma separated string
            }
            this.$element.sparkline(this.values, options);
        } else {
            this.$element.sparkline('html', options);
        }
    }
}
